import React from 'react';
import Services from '../Services/Services';

const Home = () => {
    return (
        <div>
            <Services></Services>
        </div>
    );
};

export default Home;